"use client"

import { useState, useEffect } from "react"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter, ensureInstitutionOnPayload } from "../../lib/tenant"
import "../../styles/CursoForm.css"

export default function CursoForm({ onAdded, cursoParaEditar, onCancelEdit }) {
  const { isAdmin, instituicaoId } = useAuth()
  const [nome, setNome] = useState("")
  const [departamentoId, setDepartamentoId] = useState("")
  const [departamentos, setDepartamentos] = useState([])
  const [loading, setLoading] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  useEffect(() => {
    const fetchDepartamentos = async () => {
      let query = supabase.from("departamentos").select("*").order("nome")
      query = applyInstitutionFilter(query, isAdmin, instituicaoId)
      const { data, error } = await query
      if (!error) setDepartamentos(data || [])
    }
    fetchDepartamentos()
  }, [isAdmin, instituicaoId])

  useEffect(() => {
    if (cursoParaEditar) {
      setIsEditing(true)
      setNome(cursoParaEditar.nome || "")
      setDepartamentoId(cursoParaEditar.departamento_id || "")
    } else {
      resetForm()
    }
  }, [cursoParaEditar])

  const resetForm = () => {
    setIsEditing(false)
    setNome("")
    setDepartamentoId("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!nome || !departamentoId) {
      alert("Preencha todos os campos!")
      return
    }

    setLoading(true)
    try {
      if (isEditing && cursoParaEditar) {
        const { error } = await supabase
          .from("cursos")
          .update({ nome, departamento_id: departamentoId })
          .eq("id", cursoParaEditar.id)
        if (error) throw error
        alert("Curso atualizado com sucesso!")
        if (onCancelEdit) onCancelEdit()
      } else {
        const payload = ensureInstitutionOnPayload({ nome, departamento_id: departamentoId }, isAdmin, instituicaoId)
        const { error } = await supabase.from("cursos").insert([payload])
        if (error) throw error
        alert("Curso cadastrado com sucesso!")
      }
      resetForm()
      if (onAdded) onAdded()
    } catch (err) {
      console.error("Erro ao salvar curso:", err.message)
      alert("Erro ao salvar curso: " + err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleCancelar = () => {
    resetForm()
    if (onCancelEdit) onCancelEdit()
  }

  return (
    <form className="curso-form-card" onSubmit={handleSubmit}>
      <h2 className="form-title">{isEditing ? "Editar Curso" : "Adicionar Novo Curso"}</h2>

      <div className="form-grid">
        <div className="form-group">
          <label>
            Nome do Curso <span className="required">*</span>
          </label>
          <input
            type="text"
            placeholder="Ex: Engenharia Informática"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="form-input"
            required
          />
        </div>

        <div className="form-group">
          <label>
            Departamento <span className="required">*</span>
          </label>
          <select
            value={departamentoId}
            onChange={(e) => setDepartamentoId(e.target.value)}
            className="form-input"
            required
          >
            <option value="">Selecione o departamento</option>
            {departamentos.map((dep) => (
              <option key={dep.id} value={dep.id}>
                {dep.nome}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-actions">
        {isEditing && (
          <button type="button" className="btn-cancelar" onClick={handleCancelar}>
            Cancelar
          </button>
        )}
        <button type="submit" className="btn-salvar" disabled={loading}>
          {loading ? "Salvando..." : isEditing ? "Atualizar" : "Salvar"}
        </button>
      </div>
    </form>
  )
}
